/** Designer-only constants for the shared 2D floor plan editor canvas. */

/** Dev: show boundaryWallId labels on selected room boundary segments. */
export const SHOW_ROOM_BOUNDARY_DEBUG =
  typeof process !== 'undefined' &&
  process.env?.NODE_ENV === 'development';

/** Dev: log room detection changes and rejected cycles. */
export const ROOM_DETECT_DEBUG =
  typeof process !== 'undefined' &&
  process.env?.NODE_ENV === 'development';

/** Topology uses point IDs; tolerance reserved for coordinate merge helpers. */
export const POINT_CONNECT_TOLERANCE_PX = 0.5;

/** Minimum detected room area (m²). */
export const MIN_ROOM_AREA_M2 = 0.05;

/** Exterior face filter: drop face if area >= canvasArea * this ratio. */
export const EXTERIOR_FACE_CANVAS_AREA_RATIO = 0.95;

export const DRAWABLE_WIDTH_METERS = 410;
export const DRAWABLE_HEIGHT_METERS = 410;

export const DIMENSION_SCREEN_STROKE_PX = 1;
export const DIMENSION_SCREEN_ARROW_PX = 8;
export const DIMENSION_SCREEN_FONT_PX = 12;
/** @deprecated Use DIMENSION_ARROW_TO_TEXT_GAP_PX with buildDimensionAnnotation options */
export const DIMENSION_SCREEN_TEXT_OFFSET_PX = 10;
export const DIMENSION_WALL_TO_ARROW_GAP_PX = 24;
export const DIMENSION_ARROW_TO_TEXT_GAP_PX = 14;
export const FIT_PADDING_PX = 60;
export const ZOOM_FACTOR_2D = 1.15;
export const ZOOM_FACTOR_3D = 0.85;

export const SNAP_GUIDE_SCREEN_STROKE_PX = 2.25;
export const SNAP_GUIDE_SCREEN_DASH_PX = 8;
export const SNAP_GUIDE_SCREEN_GAP_PX = 6;

export const INITIAL_VISIBLE_WIDTH_METERS = 15;
export const MIN_VISIBLE_WIDTH_METERS = 1;
export const MAX_VISIBLE_WIDTH_METERS = 100;
export const DESIGNER_MAX_ZOOM = 300;
export const DESIGNER_MIN_ZOOM_FLOOR = 0.05;
export const DRAWABLE_FRAME_STROKE_PX = 1;
export const DRAWABLE_FRAME_COLOR = '#9ca3af';
